import { safeJsonParse } from './safeJsonParse'
import { safeJsonStringify } from './safeJsonStringify'

export enum STORAGE_EVENT {
  localStorage = 'localStorage',
  sessionStorage = 'sessionStorage',
}

function dispatchStorageEvent<Value extends string | null>(key: string, newValue: Value, type: STORAGE_EVENT) {
  window.dispatchEvent(new StorageEvent(type, { key, newValue }))
}

export const getStorageItem = (key: string, type: STORAGE_EVENT) => {
  if (typeof window === 'undefined') return null
  return window[type].getItem(key)
}

export const getParsedStorageItem = <Value>(key: string, type: STORAGE_EVENT) => {
  if (typeof window === 'undefined') return null
  const storageItem = window[type].getItem(key)
  if (!storageItem) {
    return null
  }

  return safeJsonParse<Value>(storageItem)
}

export const removeStorageItem = (key: string, type: STORAGE_EVENT) => {
  if (typeof window === 'undefined') return
  window[type].removeItem(key)
  dispatchStorageEvent(key, null, type)
}

export const setStorageItem = <Value>(key: string, value: Value, type: STORAGE_EVENT) => {
  if (typeof window === 'undefined') return
  const stringifiedValue = safeJsonStringify(value)
  if (stringifiedValue) {
    try {
      window[type].setItem(key, stringifiedValue)
      dispatchStorageEvent(key, stringifiedValue, type)
    }
    catch {
      // storage 不可用（無痕／停用 web storage／quota 滿）：寫入失敗不該讓呼叫端流程中斷
      console.warn(`[storageHelper] setItem failed: ${key}`)
    }
  }
}
